(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/oddset-kambi/components/kambi-widget-utils/assets/javascripts/definitions/enetpulse-table-widget-definition.js') >= 0) return;  svs.modules.push('/modules/oddset-kambi/components/kambi-widget-utils/assets/javascripts/definitions/enetpulse-table-widget-definition.js');
"use strict";


const KambiWidgetDefinition = svs.oddset_kambi.components.kambiWidgetUtils.definitions.KambiWidgetDefinition;
const _svs$oddset_kambi$com = svs.oddset_kambi.components.kambiWidgetUtils.constants,
  WIDGET_ID = _svs$oddset_kambi$com.WIDGET_ID,
  WIDGET_TAG = _svs$oddset_kambi$com.WIDGET_TAG;
const buildFilter = svs.oddset_kambi.components.kambiWidgetUtils.buildFilter;
const ENETPULSE_FILTER = {
  fotboll: [],
  handboll: [],
  ishockey: {
    nhl: [],
    ahl: [],
    vm: [],
    'olympiska-vinterspelen': [],
    finland: ['liiga'],
    schweiz: ['nla'],
    tyskland: ['del-bundesliga']
  }
};
class EnetpulseTableWidgetDefinition extends KambiWidgetDefinition {
  constructor() {
    super(WIDGET_ID.enetpulseTable, WIDGET_TAG.enetpulseTable, {
      eventColumn2Placeholder2: [{
        widgetId: WIDGET_ID.enetpulseTable,
        order: 3,
        filter: "^(?!.*/esports).*".concat(buildFilter(ENETPULSE_FILTER))
      }]
    }, {
      live: false
    });
  }
}
setGlobal('svs.oddset_kambi.components.kambiWidgetUtils.definitions.EnetpulseTableWidgetDefinition', EnetpulseTableWidgetDefinition);

 })(window);